import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';
import DataTable from 'react-data-table-component';
import AppointmentRow from '../PianoTechAppointment/AppointmentRow';

import {
    fetchPianoTechCustomerList,
    RETURN_TO_PIANOTECHCUSTOMER_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER,
    PIANOTECHCUSTOMER_MODIFIED,
    SAVE_PIANOTECHCUSTOMER_STARTED,
    savePianoTechCustomer,
    PIANOTECHCUSTOMER_VALIDATE,
    PIANOTECHCUSTOMER_VIEW_PIANO,
    PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE,
    PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO,
    PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE,
    PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE,
    PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
    PIANOTECHCUSTOMER_PIANO_ID_CHANGE,
    PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE,
    PIANOTECHCUSTOMER_SET_DATES,
    PIANOTECHCUSTOMER_SELECTED_TECHNICIANS_ID_CHANGE,
    PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
    PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS,
    PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
    PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT,
    PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE,
    PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE,
    fetchPianoTechCustomerListByCompany,
} from '../../actions/PianoTechCustomerActions';

import {
    FIND_PIANOTECHPIANO_STARTED,
    FIND_PIANOTECHPIANO_SUCCEEDED,
    PIANOTECHPIANO_VALIDATE,
    PIANOTECHPIANO_MODIFIED,
    SAVE_PIANOTECHPIANO_STARTED,
    savePianoTechPiano,
    findPianoTechPiano,
} from '../../actions/PianoTechPianoActions';

import {
    fetchPianoTechAppointmentListForCompanyFromDate,
    PIANOTECHAPPOINTMENT_VALIDATE,
    SAVE_PIANOTECHAPPOINTMENT_STARTED,
    savePianoTechAppointment,
    PIANOTECHAPPOINTMENT_UPDATE_COMPLETE,
} from '../../actions/PianoTechAppointmentActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechCustomer,
    uiFieldInfoPianoTechPiano,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
    defaultPianoTechPiano,
    defaultPianoTechAppointment,
    uiFieldInfoPianoTechAppointment,
    defaultTravelTimes,
    defaultAppointmentTimes,
    timeZones,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechCustomer: state.pianoTechCustomer,
    pianoTechPiano: state.pianoTechPiano,
    pianoTechCompany: state.pianoTechCompany,
    pianoTechAppointment: state.pianoTechAppointment,
    pianoTechnician: state.pianoTechnician,
    user: state.user,
});

class PianoTechCustomer extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechCustomer.maintenanceType === MAINTENANCE_TYPE_COMPLETE) {
            const { adminUser, simulatingUser } = this.props.user;

            if (adminUser && !simulatingUser) {
                if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                    this.props.dispatch(fetchPianoTechCustomerList());
            } else {
                const { pianoTechCompany } = this.props.pianoTechCompany;
                if (!this.props.pianoTechCustomer.pianoTechCustomerList || this.props.pianoTechCustomer.pianoTechCustomerList.length === 0)
                    this.props.dispatch(fetchPianoTechCustomerListByCompany(pianoTechCompany.companyId));
            }
        }

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHCUSTOMER_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechCustomer.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechCustomer = Object.assign({}, this.props.pianoTechCustomer.originalPianoTechCustomer);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View Customer",
                    pianoTechCustomer,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    onPreviousWeekClick = () => {

        let { weekStartDate, weekEndDate } = this.props.pianoTechCustomer;

        console.log('Current week start date:', weekStartDate);
        console.log('Current week end date:', weekEndDate);

        // subtract 7 days to week start and end dates
        weekStartDate = new Date(new Date(weekStartDate).setDate(new Date(weekStartDate).getDate() - 7));
        weekEndDate = new Date(new Date(weekEndDate).setDate(new Date(weekEndDate).getDate() - 7));

        console.log('Previous week start date:', weekStartDate);
        console.log('Previous week end date:', weekEndDate);

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE,
            weekStartDate,
            weekEndDate,
        });

        const { currentAppointment } = this.props.pianoTechCustomer;
        const { selectedTechnicianId } = this.props.pianoTechCustomer;
        console.log(`Selected technician ID: ${selectedTechnicianId}`);
        this.buildDateAndSlots(currentAppointment, selectedTechnicianId, weekStartDate);

    }

    onNextWeekClick = () => {
        let { weekStartDate, weekEndDate } = this.props.pianoTechCustomer;

        console.log('Current week start date:', weekStartDate);
        console.log('Current week end date:', weekEndDate);

        // add 7 days to week start and end dates
        weekStartDate = new Date(new Date(weekStartDate).setDate(new Date(weekStartDate).getDate() + 7));
        weekEndDate = new Date(new Date(weekEndDate).setDate(new Date(weekEndDate).getDate() + 7));

        console.log('Next week start date:', weekStartDate);
        console.log('Next week end date:', weekEndDate);

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_WEEK_APPOINTMENT_START_DATE_CHANGE,
            weekStartDate,
            weekEndDate,
        });

        const { currentAppointment } = this.props.pianoTechCustomer;
        let { selectedTechnicianId } = this.props.pianoTechCustomer;
        console.log(`Selected technician ID: ${selectedTechnicianId}`);
        this.buildDateAndSlots(currentAppointment, selectedTechnicianId, weekStartDate);
    }

    onHideUnavailableSlotsChange = (event) => {
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_HIDE_UNAVAILABLE_SLOTS,
            hideUnavailableSlots: event.target.checked,
        });
    }

    onPianoCancelClose = () => {

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_VIEW_PIANO,
            viewingPiano: false,
        });

    }

    hideAppointments = () => {

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE,
            showAppointmentTable: false,
        });

    }

    viewAppointment = (appointmentId) => {

        console.log(`Viewing appointment with ID: ${appointmentId}`);
        const { appointmentsFromDate } = this.props.pianoTechAppointment;
        console.log(`Appointments from date: ${JSON.stringify(appointmentsFromDate)}`);

        const currentAppointment = JSON.parse(JSON.stringify(appointmentsFromDate)).find(appointment => appointment.appointmentId === appointmentId);

        console.log(`Current appointment: ${JSON.stringify(currentAppointment)}`);

        if (!currentAppointment) {
            return;
        }

        currentAppointment.displayBlockStartTime = currentAppointment.blockStartTime;
        currentAppointment.displayBlockEndTime = currentAppointment.blockEndTime;
        currentAppointment.displayTimeStart = currentAppointment.appointmentTimeStart;
        currentAppointment.displayTimeEnd = currentAppointment.appointmentTimeEnd;

        // reset update complete
        this.props.dispatch({
            type: PIANOTECHAPPOINTMENT_UPDATE_COMPLETE,
            appointmentUpdateComplete: false,
        });

        // reset delete confirmation
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT,
            confirmDeleteAppointment: false,
        });

        // set technician for the current appointment
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
            selectedTechnicianId: currentAppointment.techniciansId,
        })

        // ORIGINAL 
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE,
            originalAppointment: { ...currentAppointment },
        });

        // update appointment
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
            currentAppointment,
        });

        // show appointment
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE,
            showAppointment: true,
        });

        this.buildDateAndSlots(currentAppointment, currentAppointment.techniciansId);
    }
    addPiano = () => {
        const originalPianoTechPiano = Object.assign({}, defaultPianoTechPiano);

        const { pianoTechCompany } = this.props.pianoTechCompany;
        const { pianoTechCustomer } = this.props.pianoTechCustomer;

        originalPianoTechPiano.companyId = pianoTechCompany.companyId;
        originalPianoTechPiano.customerId = pianoTechCustomer.customerId;

        const pianoTechPiano = Object.assign({}, defaultPianoTechPiano);

        pianoTechPiano.companyId = pianoTechCompany.companyId;
        pianoTechPiano.customerId = pianoTechCustomer.customerId;

        this.props.dispatch({
            type: FIND_PIANOTECHPIANO_STARTED,
            maintenanceType: MAINTENANCE_TYPE_ADD,
            title: "Add PianoTechPiano",
        });

        this.props.dispatch({
            type: FIND_PIANOTECHPIANO_SUCCEEDED,
            pianoTechPiano,
            originalPianoTechPiano,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_VIEW_PIANO,
            viewingPiano: true,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE,
            pianoMaintenanceType: MAINTENANCE_TYPE_ADD,
        });

    }

    schedulePianoTechPiano = (pianoId) => {

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SHOW_APPOINTMENT_TABLE_CHANGE,
            showAppointmentTable: true,
        });

        // find currentPiano
        const { pianoTechPianoList } = this.props.pianoTechPiano;
        const currentPiano = pianoTechPianoList.find(piano => piano.pianoId === pianoId);

        if (currentPiano) {
            this.props.dispatch({
                type: PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE,
                currentPiano,
            });
        }

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_PIANO_ID_CHANGE,
            currentPianoId: pianoId,
        });

    }

    showAddAppointment = () => {

        console.log("Showing add appointment");

        const { currentPianoId } = this.props.pianoTechCustomer;
        const { pianoTechnicianList } = this.props.pianoTechnician;
        const { pianoTechCompany } = this.props.pianoTechCompany;

        const pianoId = currentPianoId;

        let { appointmentsFromDate } = this.props.pianoTechAppointment;

        if (!appointmentsFromDate) {
            appointmentsFromDate = [];
        }

        const { pianoTechPianoList } = this.props.pianoTechPiano;

        const currentAppointment = { ...defaultPianoTechAppointment, pianoId };

        console.log('currentAppointment:', currentAppointment);
        console.log('currentPianoId:', currentPianoId);

        const currentPiano = pianoTechPianoList.find(piano => piano.pianoId === pianoId);

        console.log('currentPiano:', currentPiano);

        if (currentPiano) {
            currentAppointment.pianoId = currentPiano.pianoId;
            currentAppointment.customerId = currentPiano.customerId;
            currentAppointment.companyId = currentPiano.companyId;
            const maintenanceType = MAINTENANCE_TYPE_ADD;
            currentAppointment.maintenanceType = maintenanceType;


            this.props.dispatch({
                type: PIANOTECHCUSTOMER_CURRENT_PIANO_CHANGE,
                currentPiano,
            });
        }

        // determine default appointment minutes
        if (pianoTechCompany && pianoTechCompany.defaultMinutesPerAppointment && Number(pianoTechCompany.defaultMinutesPerAppointment) > 0) {
            console.log('set default appointment minutes for current appointment from company:', pianoTechCompany.defaultMinutesPerAppointment)
            currentAppointment.minutesRequired = Number(pianoTechCompany.defaultMinutesPerAppointment);
        }

        if (pianoTechCompany && pianoTechCompany.defaultMinutesPerAppointment && Number(pianoTechCompany.defaultBeforeAppointmentMinutes) > 0) {
            console.log('set default before appointment minutes for current appointment from company:', pianoTechCompany.defaultBeforeAppointmentMinutes)
            currentAppointment.minutesBefore = Number(pianoTechCompany.defaultBeforeAppointmentMinutes);
        }

        if (pianoTechCompany && pianoTechCompany.defaultMinutesPerAppointment && Number(pianoTechCompany.defaultAfterAppointmentMinutes) > 0) {
            console.log('set default after appointment minutes for current appointment from company:', pianoTechCompany.defaultAfterAppointmentMinutes)
            currentAppointment.minutesAfter = Number(pianoTechCompany.defaultAfterAppointmentMinutes);
        }


        // default to selecting first piano technician
        if (pianoTechnicianList && pianoTechnicianList.length > 0) {
            console.log('set default appointment minutes for current appointment from technician:', pianoTechnicianList[0].defaultMinutesPerAppointment)
            currentAppointment.techniciansId = pianoTechnicianList[0].techniciansId;
            if (Number(pianoTechnicianList[0].defaultMinutesPerAppointment) > 0) {
                console.log('set default appointment minutes for current appointment from technician:', pianoTechnicianList[0].defaultMinutesPerAppointment)
                currentAppointment.minutesRequired = Number(pianoTechnicianList[0].defaultMinutesPerAppointment);
            }
            if (Number(pianoTechnicianList[0].defaultBeforeAppointmentMinutes) > 0) {
                console.log('set default before appointment minutes for current appointment from technician:', pianoTechnicianList[0].defaultBeforeAppointmentMinutes)
                currentAppointment.minutesBefore = Number(pianoTechnicianList[0].defaultBeforeAppointmentMinutes);
            }
            if (Number(pianoTechnicianList[0].defaultAfterAppointmentMinutes) > 0) {
                console.log('set default after appointment minutes for current appointment from technician:', pianoTechnicianList[0].defaultAfterAppointmentMinutes)
                currentAppointment.minutesAfter = Number(pianoTechnicianList[0].defaultAfterAppointmentMinutes);
            }
        }

        if (currentPiano && Number(currentPiano.defaultMinutesPerAppointment) > 0) {
            console.log('Setting default appointment minutes for current appointment from piano:', currentPiano.defaultMinutesPerAppointment)
            currentAppointment.minutesRequired = Number(currentPiano.defaultMinutesPerAppointment);
        }

        // reset update complete
        this.props.dispatch({
            type: PIANOTECHAPPOINTMENT_UPDATE_COMPLETE,
            appointmentUpdateComplete: false,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
            currentAppointment,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SHOW_APPOINTMENT_CHANGE,
            showAppointment: true,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_ORIGINAL_APPOINTMENT_CHANGE,
            originalAppointment: { ...currentAppointment },
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
            selectedTechnicianId: currentAppointment.techniciansId,
        });

        this.buildDateAndSlots(currentAppointment, currentAppointment.techniciansId);

    }

    buildDateAndSlots = (currentAppointment, selectedTechnicianId, weekStartDate) => {
        // scheduling will show a Sunday as the first day of the week
        // determine the first day of the week for the scheduling component
        console.log('Building date and slots for current appointment:', currentAppointment);
        console.log('Week start date passed to buildDateAndSlots:', weekStartDate);

        const firstDayOfWeek = 0; // Sunday

        let needToCalculateSunday = true;

        // calculate the Sunday of the current week
        let today = new Date();

        if (weekStartDate) {
            console.log('Using provided week start date. Week start date is set to:', weekStartDate);
            today = weekStartDate;
            console.log('Today is set to:', today);
            needToCalculateSunday = false;
        }

        let sunday = new Date(today);
        let saturday = new Date(sunday);
        saturday.setDate(sunday.getDate() + 6);

        console.log('Initial Sunday:', sunday);
        console.log('Initial Saturday:', saturday);


        if (needToCalculateSunday) {
            console.log('Need to calculate Sunday for the current week.');
            const currentDay = today.getDay();

            console.log('Current day of the week:', currentDay);
            console.log('First day of the week (Sunday):', firstDayOfWeek);
            const diffToSunday = currentDay - firstDayOfWeek;
            console.log('Difference to Sunday:', diffToSunday);
            sunday = new Date(today);
            sunday.setDate(today.getDate() - diffToSunday);
            console.log('Calculated Sunday of the current week:', sunday);

            // calculate the Saturday of the current week
            saturday = new Date(sunday);
            saturday.setDate(sunday.getDate() + 6);
            console.log('Calculated Saturday of the current week:', saturday);
        }

        // set sunday time to 00:00:00 and saturday time to 23:59:59
        sunday.setHours(0, 0, 0, 0);
        saturday.setHours(23, 59, 59, 999);
        console.log('Sunday start time set to:', sunday);
        console.log('Saturday end time set to:', saturday);


        let technicianId = selectedTechnicianId;

        console.log('Initial technicianId:', technicianId);

        if (technicianId === 0) {
            technicianId = currentAppointment.techniciansId;
        }

        console.log('selectedTechnicianId is set to ', technicianId);
        console.log('Building time slots with appointments from date:', this.props.pianoTechAppointment.appointmentsFromDate);

        const timeslots = this.buildTimeSlots(this.props.pianoTechAppointment.appointmentsFromDate, sunday, saturday, technicianId, currentAppointment);

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_SET_DATES,
            weekStartDate: sunday,
            weekEndDate: saturday,
            timeslots,
        });

    }

    // create a routine to build 48 half hour time slots for the 7 day week and go through list of existing appointments for that day 
    // and mark the occupied time slots accordingly
    buildTimeSlots = (existingAppointments, startDate, endDate, techniciansId, currentAppointment) => {
        console.log('Building time slots for techniciansId:', techniciansId);
        console.log('Start date:', startDate);
        console.log('End date:', endDate);
        console.log('Current appointment:', currentAppointment);
        console.log('Existing Appointments:', existingAppointments);

        let technicianUtcHoursAdjustment = 0;
        let customerUtcHoursAdjustment = 0;

        // find technician in list to get utcHoursAdjustment
        const technician = this.props.pianoTechnician.pianoTechnicianList.find(tech => tech.techniciansId === techniciansId);
        if (technician) {
            technicianUtcHoursAdjustment = parseInt(technician.utcHoursAdjustment, 10) || 0;
            technicianUtcHoursAdjustment = 0 - (technicianUtcHoursAdjustment / 60);
        }

        console.log('Technician UTC Hours Adjustment after lookup:', technicianUtcHoursAdjustment);

        const customer = this.props.pianoTechCustomer.pianoTechCustomerList.find(cust => cust.customerId === currentAppointment.customerId);

        if (customer) {
            customerUtcHoursAdjustment = parseInt(customer.utcHoursAdjustment, 10) || 0;
            customerUtcHoursAdjustment = 0 - (customerUtcHoursAdjustment / 60);
        }

        console.log('Customer UTC Hours Adjustment after lookup:', customerUtcHoursAdjustment);


        let timeSlots = [];

        let appointments = JSON.parse(JSON.stringify(existingAppointments));

        for (let day = 0; day < 7; day++) {
            timeSlots[day] = [];
            // create variable with just the date
            const currentDate = new Date(startDate);
            currentDate.setDate(startDate.getDate() + day);
            const dateString = currentDate.toISOString().split('T')[0];


            // create 96 15 minute time slots for the current day
            for (let i = 0; i < 96; i++) {
                // build time for slot (i.e. 00:00, 00:15, 00:30, etc.)
                const hours = Math.floor(i / 4);
                const minutes = (i % 4) * 15;
                const startTimeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                const endTimeString = `${hours.toString().padStart(2, '0')}:${(minutes + 15).toString().padStart(2, '0')}`;

                // calculate custstarttime and custendtime based on customerUtcHoursAdjustment
                const custStartTime = new Date(currentDate);
                console.log('Customer start time before adjustment:', custStartTime);
                // get integer portion of customerUtcHoursAdjustment
                //const customerUtcHoursAdjustmentInt = Math.floor(customerUtcHoursAdjustment);
                //const customerUtcHoursAdjustmentFraction = customerUtcHoursAdjustment - customerUtcHoursAdjustmentInt;
                //console.log('customerUtcHoursAdjustmentInt=', customerUtcHoursAdjustmentInt);
                //console.log('customerUtcHoursAdjustmentFraction=', customerUtcHoursAdjustmentFraction);
                const custhours = hours - customerUtcHoursAdjustment + technicianUtcHoursAdjustment;
                console.log('custhours=', custhours);
                custStartTime.setHours(custhours);
                custStartTime.setMinutes(minutes);
                console.log('Customer start time after adjustment:', custStartTime);
                console.log('hours=', hours);
                console.log('minutes=', minutes);
                console.log('customerUtcHoursAdjustment=', customerUtcHoursAdjustment);
                console.log('technicianUtcHoursAdjustment=', technicianUtcHoursAdjustment);

                const custEndTime = new Date(custStartTime);
                custEndTime.setMinutes(custEndTime.getMinutes() + 15);

                const custStartTimeString = `${custhours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
                const custEndTimeString = `${custhours.toString().padStart(2, '0')}:${(minutes + 15).toString().padStart(2, '0')}`;

                console.log('Customer start time string:', custStartTimeString);
                console.log('Customer end time string:', custEndTimeString);

                timeSlots[day].push({
                    index: i,
                    occupied: false,
                    date: dateString,
                    starttime: startTimeString,
                    endtime: endTimeString,
                    custstarttime: custStartTimeString,
                    custendtime: custEndTimeString,
                    selected: false,
                    outOfSchedule: false,
                });
            }
        }

        let currentAppointmentId = 0;

        if (currentAppointment && currentAppointment.appointmentId) {
            currentAppointmentId = currentAppointment.appointmentId;
        }

        console.log('Check if current appointment should be removed from list of appointments:', currentAppointment);
        console.log('Current list of appointments before adding current appointment if new:', appointments);

        // if current appointment is not new, remove from existing list and replace with currentAppointment
        if (currentAppointmentId !== 0) {
            appointments = appointments.filter(appointment => appointment.appointmentId !== currentAppointmentId);
        }

        console.log('Current list of appointments after removing current appointment if not new:', appointments);

        console.log('Add current appointment to list if there is a time selected');
        if (!currentAppointment.appointmentTimeStart || !currentAppointment.appointmentTimeEnd) {
            console.log('Current appointment does not have a time selected, skipping add to list:', currentAppointment);
        } else {
            appointments.push(currentAppointment);
        }

        appointments.forEach(appointment => {
            console.log('Processing appointment:', appointment);

            // if appointment is prior to the current week, skip it
            const appointmentDate = new Date(appointment.appointmentTimeStart.replace('T', ' ').replace('Z', ''));
            if (appointmentDate < startDate) {
                console.log('Skipping appointment prior to the current week:', appointment);
                return;
            }

            if (appointmentDate > endDate) {
                console.log('Skipping appointment after the current week:', appointment);
                return;
            }

            if (appointment.techniciansId === techniciansId) {
                console.log('Appointment belongs to current technician:', appointment);
                if (appointment.appointmentId === currentAppointmentId) {
                    // if time slot exactly matches the current appointment, mark it as selected
                    console.log('Should mark current appointment as selected:', appointment);
                    // remove T and Z from appointmentTimeStart and appointmentTimeEnd
                    appointment.appointmentTimeStart = appointment.appointmentTimeStart.replace('T', ' ').replace('Z', '');
                    appointment.appointmentTimeEnd = appointment.appointmentTimeEnd.replace('T', ' ').replace('Z', '');
                    const appointmentStart = new Date(appointment.appointmentTimeStart);
                    const appointmentEnd = new Date(appointment.appointmentTimeEnd);
                    console.log('appointmentStart:', appointmentStart, ' appointmentEnd:', appointmentEnd);
                    console.log('hours=', appointmentStart.getHours(), ' minutes=', appointmentStart.getMinutes());
                    const startSlot = Math.floor((appointmentStart.getHours() * 60 + appointmentStart.getMinutes()) / 15);
                    const endSlot = Math.floor((appointmentEnd.getHours() * 60 + appointmentEnd.getMinutes()) / 15);

                    console.log('Current appointment startSlot:', startSlot, ' endSlot:', endSlot);
                    let marked = false;
                    for (let i = startSlot; i < endSlot; i++) {
                        if (timeSlots[appointmentStart.getDay()] && timeSlots[appointmentStart.getDay()][i] && !marked) {
                            timeSlots[appointmentStart.getDay()][i].selected = true;
                            marked = true;
                            console.log('Marked current appointment as selected i:', i, ' appointmentStart.getDay():', appointmentStart.getDay());
                        }
                    }
                } else {
                    // if appointment is within the startDate and endDate range
                    console.log('Processing non-current appointment:', appointment);
                    const appointmentStart = new Date(appointment.blockStartTime);
                    const appointmentEnd = new Date(appointment.blockEndTime);
                    if (appointmentStart >= startDate && appointmentEnd <= endDate && appointment.techniciansId === techniciansId) {
                        const startSlot = Math.floor((appointmentStart.getHours() * 60 + appointmentStart.getMinutes()) / 15);
                        const endSlot = Math.floor((appointmentEnd.getHours() * 60 + appointmentEnd.getMinutes()) / 15);
                        console.log('check if appointment is within the time slots:', appointment);
                        for (let i = startSlot; i < endSlot; i++) {
                            if (timeSlots[appointmentStart.getDay()] && timeSlots[appointmentStart.getDay()][i]) {
                                timeSlots[appointmentStart.getDay()][i].occupied = true;
                                console.log('Marking time slot as occupied:', appointment);
                            }
                        }
                    }
                }
            } else {
                console.log('Appointment is outside the startDate and endDate range or does not match the technician ID:', appointment);
            }
        });

        // now find the available time slots for the selected technician
        // if time slot is outside of work schedule for technician, then mark it as outOfSchedule

        console.log('Finding available time slots for the selected technician:', techniciansId);

        const { pianoTechnicianList } = this.props.pianoTechnician;

        if (!technician) {
            console.error('Technician not found for selectedTechnicianId:', techniciansId);
            return timeSlots;
        }

        console.log('Technician working hours:', technician);

        const sundayStartHour = Number(technician.sundayStartTime.substring(0, 2));
        const sundayStartMinute = Number(technician.sundayStartTime.substring(2, 4));
        const sundayEndHour = Number(technician.sundayStopTime.substring(0, 2));
        const sundayEndMinute = Number(technician.sundayStopTime.substring(2, 4));
        let dayIndex = 0;

        console.log('Sunday start time:', sundayStartHour, sundayStartMinute);
        console.log('Sunday end time:', sundayEndHour, sundayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, sundayStartHour, sundayStartMinute, sundayEndHour, sundayEndMinute, dayIndex);

        const mondayStartHour = Number(technician.mondayStartTime.substring(0, 2));
        const mondayStartMinute = Number(technician.mondayStartTime.substring(2, 4));
        const mondayEndHour = Number(technician.mondayStopTime.substring(0, 2));
        const mondayEndMinute = Number(technician.mondayStopTime.substring(2, 4));
        dayIndex = 1;

        console.log('Monday start time:', mondayStartHour, mondayStartMinute);
        console.log('Monday end time:', mondayEndHour, mondayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, mondayStartHour, mondayStartMinute, mondayEndHour, mondayEndMinute, dayIndex);

        const tuesdayStartHour = Number(technician.tuesdayStartTime.substring(0, 2));
        const tuesdayStartMinute = Number(technician.tuesdayStartTime.substring(2, 4));
        const tuesdayEndHour = Number(technician.tuesdayStopTime.substring(0, 2));
        const tuesdayEndMinute = Number(technician.tuesdayStopTime.substring(2, 4));
        dayIndex = 2;

        console.log('Tuesday start time:', tuesdayStartHour, tuesdayStartMinute);
        console.log('Tuesday end time:', tuesdayEndHour, tuesdayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, tuesdayStartHour, tuesdayStartMinute, tuesdayEndHour, tuesdayEndMinute, dayIndex);

        const wednesdayStartHour = Number(technician.wednesdayStartTime.substring(0, 2));
        const wednesdayStartMinute = Number(technician.wednesdayStartTime.substring(2, 4));
        const wednesdayEndHour = Number(technician.wednesdayStopTime.substring(0, 2));
        const wednesdayEndMinute = Number(technician.wednesdayStopTime.substring(2, 4));
        dayIndex = 3;

        console.log('Wednesday start time:', wednesdayStartHour, wednesdayStartMinute);
        console.log('Wednesday end time:', wednesdayEndHour, wednesdayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, wednesdayStartHour, wednesdayStartMinute, wednesdayEndHour, wednesdayEndMinute, dayIndex);

        const thursdayStartHour = Number(technician.thursdayStartTime.substring(0, 2));
        const thursdayStartMinute = Number(technician.thursdayStartTime.substring(2, 4));
        const thursdayEndHour = Number(technician.thursdayStopTime.substring(0, 2));
        const thursdayEndMinute = Number(technician.thursdayStopTime.substring(2, 4));
        dayIndex = 4;

        console.log('Thursday start time:', thursdayStartHour, thursdayStartMinute);
        console.log('Thursday end time:', thursdayEndHour, thursdayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, thursdayStartHour, thursdayStartMinute, thursdayEndHour, thursdayEndMinute, dayIndex);

        const fridayStartHour = Number(technician.fridayStartTime.substring(0, 2));
        const fridayStartMinute = Number(technician.fridayStartTime.substring(2, 4));
        const fridayEndHour = Number(technician.fridayStopTime.substring(0, 2));
        const fridayEndMinute = Number(technician.fridayStopTime.substring(2, 4));
        dayIndex = 5;

        console.log('Friday start time:', fridayStartHour, fridayStartMinute);
        console.log('Friday end time:', fridayEndHour, fridayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, fridayStartHour, fridayStartMinute, fridayEndHour, fridayEndMinute, dayIndex);

        const saturdayStartHour = Number(technician.saturdayStartTime.substring(0, 2));
        const saturdayStartMinute = Number(technician.saturdayStartTime.substring(2, 4));
        const saturdayEndHour = Number(technician.saturdayStopTime.substring(0, 2));
        const saturdayEndMinute = Number(technician.saturdayStopTime.substring(2, 4));
        dayIndex = 6;

        console.log('Saturday start time:', saturdayStartHour, saturdayStartMinute);
        console.log('Saturday end time:', saturdayEndHour, saturdayEndMinute);

        timeSlots = this.updateSlotsForTechnicianHours(timeSlots, saturdayStartHour, saturdayStartMinute, saturdayEndHour, saturdayEndMinute, dayIndex);

        return timeSlots;
    }

    updateSlotsForTechnicianHours = (timeSlots, startHour, startMinute, endHour, endMinute, dayIndex) => {

        console.log('Updating slots for technician hours:', startHour, startMinute, endHour, endMinute, dayIndex);

        for (let i = 0; i < timeSlots[dayIndex].length; i++) {
            const slot = timeSlots[dayIndex][i];
            console.log('Checking time slot:', slot);
            const slotHour = Number(slot.starttime.toString().substring(0, 2));
            const slotMinute = Number(slot.starttime.toString().substring(3, 5));

            console.log('Slot hour and minute:', slotHour, slotMinute);

            if (
                slotHour < startHour ||
                (slotHour === startHour && slotMinute < startMinute) ||
                slotHour > endHour ||
                (slotHour === endHour && slotMinute >= endMinute) ||
                (startHour === 0 && startMinute === 0 && endHour === 0 && endMinute === 0)
            ) {
                slot.outOfSchedule = true;
                console.log('Marking time slot as out of schedule:', slot);
            }

        }

        return timeSlots;
    }

    viewPianoTechPiano = (pianoId) => {
        console.log('Viewing piano tech piano with ID:', pianoId);
        this.props.dispatch(findPianoTechPiano(pianoId));
        this.props.dispatch({
            type: PIANOTECHCUSTOMER_PIANO_MAINTENANCE_TYPE,
            pianoMaintenanceType: MAINTENANCE_TYPE_EDIT,
        });

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO,
            confirmDeletePiano: false,
        });
    }

    editPianoTechCustomer = () => {
        const pianoTechCustomer = this.props.pianoTechCustomer.pianoTechCustomer;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechCustomer",
            pianoTechCustomer,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechCustomer.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechCustomer = this.props.pianoTechCustomer.pianoTechCustomer;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHCUSTOMER,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechCustomer",
                    pianoTechCustomer,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechCustomer.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechCustomer';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechCustomer';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechCustomer';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHCUSTOMER_STARTED,
            message,
        })

        const { pianoTechCustomer } = this.props.pianoTechCustomer;
        pianoTechCustomer.maintenanceType = this.props.pianoTechCustomer.maintenanceType;
        this.props.dispatch(savePianoTechCustomer(pianoTechCustomer));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechCustomer } = this.props.pianoTechCustomer;
        pianoTechCustomer[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_MODIFIED,
            pianoTechCustomer,
        })

    }

    onAppointmentChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { currentAppointment } = this.props.pianoTechCustomer;
        console.log('currentAppointment before change:', currentAppointment);

        if (fieldName === 'selectedTechnicianId') {
            console.log('selectedTechnicianId change detected with fieldValue:', fieldValue);
            // rebuild availabilty
            const { weekStartDate, weekEndDate } = this.props.pianoTechCustomer;

            const techniciansId = fieldValue;
            console.log('rebuild timeslots after technician change techniciansId:', techniciansId);
            console.log('Building time slots with appointments from date:', this.props.pianoTechAppointment.appointmentsFromDate, 'weekStartDate:', weekStartDate, 'weekEndDate:', weekEndDate, 'techniciansId:', techniciansId, 'currentAppointment:', currentAppointment);
            console.log('this.props.pianoTechAppointment.appointmentsFromDate:', this.props.pianoTechAppointment.appointmentsFromDate);
            const timeslots = this.buildTimeSlots(this.props.pianoTechAppointment.appointmentsFromDate, weekStartDate, weekEndDate, techniciansId, currentAppointment);

            this.props.dispatch({
                type: PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
                timeslots,
            });

            this.props.dispatch({
                type: PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
                selectedTechnicianId: fieldValue,
            });

            return;
        }

        currentAppointment[fieldName] = fieldValue;

        if (fieldName === 'tuning') {
            if (fieldValue && currentAppointment.serviceReason === '') {
                currentAppointment.serviceReason = 'Tuning';
            }
        }


        if (fieldName === 'minutesRequired' || fieldName === 'minutesBefore' || fieldName === 'minutesAfter') {
            // clear appointment time selected
            currentAppointment.appointmentTimeStart = '';
            currentAppointment.appointmentTimeEnd = '';
            currentAppointment.displayTimeStart = '';
            currentAppointment.displayTimeEnd = '';
            currentAppointment.blockStartTime = '';
            currentAppointment.blockEndTime = '';
            currentAppointment.displayBlockStartTime = '';
            currentAppointment.displayBlockEndTime = '';

            const { timeslots } = this.props.pianoTechCustomer;
            // clear selected time slots
            timeslots.forEach(daySlots => {
                daySlots.forEach(slot => {
                    slot.selected = false;
                });
            });

            this.props.dispatch({
                type: PIANOTECHCUSTOMER_UPDATE_TIMESLOTS,
                timeslots,
            });
        }

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_APPOINTMENT_CHANGE,
            currentAppointment,
        });


    }

    formValid = () => {
        const { pianoTechCustomer, maintenanceType } = this.props.pianoTechCustomer;
        const validFormInfo = validateForm(uiFieldInfoPianoTechCustomer, pianoTechCustomer, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechCustomer, maintenanceType } = this.props.pianoTechCustomer;
        const validInfo = validateForm(uiFieldInfoPianoTechCustomer, pianoTechCustomer, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHCUSTOMER_VALIDATE,
            message,
            messageType,
        })
    }

    onPianoValidate = () => {
        const { pianoTechPiano, maintenanceType } = this.props.pianoTechPiano;
        const validInfo = validateForm(uiFieldInfoPianoTechPiano, pianoTechPiano, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHPIANO_VALIDATE,
            message,
            messageType,
        })
    }

    deleteAppointment = () => {
        const { confirmDeleteAppointment, currentAppointment } = this.props.pianoTechCustomer;

        if (!confirmDeleteAppointment) {
            this.props.dispatch({
                type: PIANOTECHCUSTOMER_CONFIRM_DELETE_APPOINTMENT,
                confirmDeleteAppointment: true,
            });

            return;
        }

        this.props.dispatch({
            type: SAVE_PIANOTECHAPPOINTMENT_STARTED,
            message: 'Deleting piano tech appointment.',
        })

        currentAppointment.maintenanceType = MAINTENANCE_TYPE_DELETE;

        this.props.dispatch(savePianoTechAppointment(currentAppointment));
    }

    saveAppointment = () => {
        let message = '';

        const { currentAppointment, appointmentsFromDate } = this.props.pianoTechCustomer;
        let maintenanceType = MAINTENANCE_TYPE_EDIT;

        if (currentAppointment && currentAppointment.appointmentId === 0) {
            maintenanceType = MAINTENANCE_TYPE_ADD;
        }

        this.props.dispatch({
            type: SAVE_PIANOTECHAPPOINTMENT_STARTED,
            message,
        })

        currentAppointment.maintenanceType = maintenanceType;
        this.props.dispatch(savePianoTechAppointment(currentAppointment));
    }

    onAppointmentValidate = () => {
        console.log('onAppointmentValidate called');
        const { currentAppointment } = this.props.pianoTechCustomer;

        let maintenanceType = MAINTENANCE_TYPE_EDIT;

        if (currentAppointment && currentAppointment.maintenanceType) {
            maintenanceType = currentAppointment.maintenanceType;
        }

        const validInfo = validateForm(uiFieldInfoPianoTechAppointment, currentAppointment, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHAPPOINTMENT_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechCustomer, originalPianoTechCustomer, maintenanceType } = this.props.pianoTechCustomer

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechCustomer, pianoTechCustomer, originalPianoTechCustomer)

    }

    onPianoSave = () => {
        let message = '';
        console.log('onPianoSave this.props.pianoTechCustomer.pianoMaintenanceType: ' + this.props.pianoTechCustomer.pianoMaintenanceType);

        switch (this.props.pianoTechCustomer.pianoMaintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechPiano';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechPiano';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHPIANO_STARTED,
            message,
        })

        const { pianoTechPiano } = this.props.pianoTechPiano;
        pianoTechPiano.maintenanceType = this.props.pianoTechCustomer.pianoMaintenanceType;
        console.log('onPianoSave pianoTechPiano: ' + JSON.stringify(pianoTechPiano));
        pianoTechPiano.updatePianoListForCustomer = true;
        this.props.dispatch(savePianoTechPiano(pianoTechPiano));
    }

    onPianoDelete = () => {

        const { confirmDeletePiano } = this.props.pianoTechCustomer;

        if (!confirmDeletePiano) {
            return this.props.dispatch({
                type: PIANOTECHCUSTOMER_CONFIRM_DELETE_PIANO,
                confirmDeletePiano: true,
            });
        }

        let message = '';

        const { pianoTechPiano } = this.props.pianoTechPiano;
        pianoTechPiano.maintenanceType = MAINTENANCE_TYPE_DELETE;
        this.props.dispatch({
            type: SAVE_PIANOTECHPIANO_STARTED,
            message,
        })

        pianoTechPiano.updatePianoListForCustomer = true;
        this.props.dispatch(savePianoTechPiano(pianoTechPiano));
    }

    onPianoChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechPiano } = this.props.pianoTechPiano;
        pianoTechPiano[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHPIANO_MODIFIED,
            pianoTechPiano,
        })

    }

    pianoFormValid = () => {
        const { pianoTechPiano, maintenanceType } = this.props.pianoTechPiano;
        const validFormInfo = validateForm(uiFieldInfoPianoTechPiano, pianoTechPiano, maintenanceType);

        return validFormInfo.valid;
    }

    pianoValidate = () => {
        const { pianoTechPiano, maintenanceType } = this.props.pianoTechPiano;
        const validInfo = validateForm(uiFieldInfoPianoTechPiano, pianoTechPiano, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHPIANO_VALIDATE,
            message,
            messageType,
        })
    }

    pianoCheckForChanges = () => {
        const { pianoTechPiano, originalPianoTechPiano, maintenanceType } = this.props.pianoTechPiano

        if (!this.pianoFormValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechPiano, pianoTechPiano, originalPianoTechPiano)

    }

    appointmentCheckForChanges = () => {
        const { currentAppointment, originalAppointment } = this.props.pianoTechCustomer;

        if (!this.appointmentFormValid())
            return false;

        if (currentAppointment.appointmentId === 0) {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechAppointment, currentAppointment, originalAppointment);
    }

    appointmentFormValid = () => {
        const { currentAppointment } = this.props.pianoTechCustomer;
        let maintenanceType = MAINTENANCE_TYPE_EDIT;

        if (currentAppointment.appointmentId === 0) {
            maintenanceType = MAINTENANCE_TYPE_ADD;
        }

        const validFormInfo = validateForm(uiFieldInfoPianoTechAppointment, currentAppointment, maintenanceType);

        return validFormInfo.valid;
    }
    render() {

        const pianoColumns = [
            {
                name: 'Piano Id',
                selector: row => row.pianoId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Device Type',
                selector: row => row.deviceType,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Year',
                selector: row => row.year,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Make',
                selector: row => row.make,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Model',
                selector: row => row.model,
                sortable: true,
                width: '10%',
            },
            {
                name: 'SerialNumber',
                selector: row => row.serialNumber,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Nickname',
                selector: row => row.nickname,
                sortable: true,
                width: '10%',
            },
            {
                name: 'DefaultMinutesPerAppointment',
                selector: row => row.defaultMinutesPerAppointment,
                sortable: true,
                width: '10%',
            },
            {
                name: 'View',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton2"
                            onClick={() => { this.viewPianoTechPiano(row.pianoId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
            {
                name: 'Schedule',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton"
                            onClick={() => { this.schedulePianoTechPiano(row.pianoId) }}
                            style={{ marginRight: "5px" }}
                        >Schedule
                        </button>
                    </>
                )
            },
        ]

        const appointmentColumns = [
            {
                name: 'Appointment Id',
                selector: row => row.appointmentId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Piano Id',
                selector: row => row.pianoId,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Technician Name',
                selector: row => row.technicianName,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Service Reason',
                selector: row => row.serviceReason,
                sortable: true,
                width: '30%',
            },
            {
                name: 'Tech Start Time',
                selector: row => row.appointmentTimeStart,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Tech End Time',
                selector: row => row.appointmentTimeEnd,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Cust Start Time',
                selector: row => row.customerAppointmentTimeStart,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Cust End Time',
                selector: row => row.customerAppointmentTimeEnd,
                sortable: true,
                width: '10%',
            },
            {
                name: 'Minutes Required',
                selector: row => row.minutesRequired,
                sortable: true,
                width: '10%',
            },
            {
                name: 'View',
                width: '8%',
                cell: row =>
                (
                    <>
                        <button
                            className="bluebutton"
                            onClick={() => { this.viewAppointment(row.appointmentId) }}
                            style={{ marginRight: "5px" }}
                        >View
                        </button>
                    </>
                )
            },
        ]

        const customStyles = {
            rows: {
                style: {
                    minheight: '20px',
                }
            }
        }

        const { weekStartDate, weekEndDate, pianoTechCustomer, viewingPiano, confirmDeletePiano, showAppointmentTable, currentPiano, confirmDeleteAppointment,
            currentPianoId, showAppointment, currentAppointment, timeslots, hideUnavailableSlots } = this.props.pianoTechCustomer;
        let { selectedTechnicianId } = this.props.pianoTechCustomer;
        const { adminUser, simulatingUser } = this.props.user;
        const { pianoTechPianoList, pianoTechPiano } = this.props.pianoTechPiano;
        const { appointmentsFromDate, appointmentUpdateComplete } = this.props.pianoTechAppointment;
        const { appointmentsFromDateRetrieved, appointmentsFromDateRetrieveStarted } = this.props.pianoTechAppointment;
        const { pianoTechnicianList } = this.props.pianoTechnician;

        let displayPianoTechList = [];
        let displayAppointments = [];
        let appointmentDisabled = false;
        let pianoName = '';
        let technicianName = '';
        let appointmentDeleteText = 'Delete';
        let showLeftDateButton = false, showRightDateButton = false;

        if (confirmDeleteAppointment) {
            appointmentDeleteText = 'Confirm Delete';
        }

        if (selectedTechnicianId === 0) {

            selectedTechnicianId = pianoTechnicianList.length > 0 ? pianoTechnicianList[0].techniciansId : 0;
            if (currentAppointment && currentAppointment.techniciansId) {
                console.log('use selectedTechnicianId from currentAppointment:', currentAppointment.techniciansId);
                selectedTechnicianId = currentAppointment.techniciansId;
            }

            // This should be set when the component is first rendered and no technician is selected.
            // update redux with selected technician ID
            //console.log('dispatching selectedTechnicianId change with:', selectedTechnicianId);
            //this.props.dispatch({
            //    type: PIANOTECHCUSTOMER_SELECTED_TECHNICIAN_CHANGE,
            //    selectedTechnicianId,
            //})

        }

        console.log('currentAppointment =', JSON.stringify(currentAppointment));
        // find technician name based on currentAppointment.techniciansId
        if (currentAppointment) {
            console.log('search for technician with ID', currentAppointment.techniciansId);
            console.log('pianoTechnicianList:', pianoTechnicianList);
            const technician = pianoTechnicianList.find(technician => technician.techniciansId === currentAppointment.techniciansId);
            if (technician) {
                technicianName = technician.technicianName;
            }

            console.log('found technician:', technician);
            console.log('technicianName:', technicianName);
        }

        if (currentPiano) {
            console.log('currentPiano =', JSON.stringify(currentPiano));
            pianoName = currentPiano.nickname;
        }

        // get appointments for customer
        console.log('appointmentsFromDateRetrieved=', appointmentsFromDateRetrieved);


        if (!appointmentsFromDateRetrieved && !appointmentsFromDateRetrieveStarted) {
            console.log('Fetching piano tech appointments from date', new Date().toISOString());
            this.props.dispatch(fetchPianoTechAppointmentListForCompanyFromDate(this.props.pianoTechCompany.pianoTechCompany.companyId, new Date().toISOString()));
        } else {
            // if appointmentsFromDate is not empty, filter the list to only include appointments that belong to this piano
            if (showAppointmentTable && appointmentsFromDate && appointmentsFromDate.length > 0 && currentPiano) {
                displayAppointments = appointmentsFromDate.filter(appointment => appointment.pianoId === currentPiano.pianoId);
            }
        }

        // if pianoTechPianoList is not empty, filter the list to only include pianos that belong to this customer
        if (pianoTechPianoList && pianoTechPianoList.length > 0) {
            displayPianoTechList = pianoTechPianoList.filter(piano => piano.customerId === pianoTechCustomer.customerId);
        }

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete',
            showPianoDelete = false, disablePianoSave = false, pianoCancelCloseText = 'Cancel', pianoDeleteText = 'Delete';

        if (confirmDeletePiano) {
            pianoDeleteText = 'Confirm Delete';
        }

        let pianoMaintenanceComplete = false;

        console.log('pianoTechPiano:', pianoTechPiano);

        if (pianoTechPiano) {
            console.log('pianoTechPiano exists:', JSON.stringify(pianoTechPiano));
        }
        if (pianoTechPiano && pianoTechPiano.complete === true) {
            pianoMaintenanceComplete = true;
            pianoCancelCloseText = 'Close';
        }

        switch (this.props.pianoTechCustomer.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        if (viewingPiano) {
            disablePianoSave = !this.pianoCheckForChanges();
        }

        let appointmentSlotHtml = [];

        let date1, date2, date3, date4, date5, date6, date7;

        // I want to build a table for the 7-day schedule of appointment slots
        // There will be 8 columns across, one for header, and one for each of the 7 days
        // Below each day, there will be 48 half-hour time slots
        // There will be a button for each of the 48 half-hour time slots with the start time as text
        // The button will be disabled if the time slot is already booked or there isn't enough time for a new appointment in that slot

        let currentTechnicianName = '';

        let disableAppointmentSave = false;

        if (showAppointment) {
            disableAppointmentSave = !this.appointmentCheckForChanges();

            console.log('showAppointment is true, timeSlots:', timeslots);
            let currentTechnician = '';

            // Initialize the current technician before looping through the time slots
            if (currentAppointment && currentAppointment.techniciansId) {
                currentTechnician = this.props.pianoTechnician.pianoTechnicianList.find(
                    tech => tech.techniciansId === currentAppointment.techniciansId
                ) || '';

                console.log(`Current technician: ${JSON.stringify(currentTechnician)}`);
                currentTechnicianName = currentTechnician ? currentTechnician.technicianName : '';
            }


            // calculate the number of 15 minute slots required for the current appointment
            let slotsRequired = 4; // default
            let slotsBefore = 0;
            let slotsAfter = 0;
            if (currentAppointment) {
                slotsRequired = Math.ceil(currentAppointment.minutesRequired / 15);
                slotsBefore = Math.ceil(currentAppointment.minutesBefore / 15);
                slotsAfter = Math.ceil(currentAppointment.minutesAfter / 15) + (slotsRequired - 1);
            }

            console.log('# of slots required for current appointment:', slotsRequired);
            console.log('# of slots before current appointment:', slotsBefore);
            console.log('# of slots after current appointment:', slotsAfter);

            console.log('timeslots = ', JSON.stringify(timeslots))
            // loop through the time slots
            for (let i = 0; i < 96; i++) {
                const avail = [];
                const selected = [];
                const outOfSchedule = [];
                for (let j = 0; j < 7; j++) {
                    // timeslot model uses "occupied"; convert to available
                    console.log('check timeslot:', timeslots[j][i]);
                    let availableTimeSlot = !timeslots[j][i].occupied;
                    let outOfScheduleFlag = timeslots[j][i].outOfSchedule;
                    outOfSchedule.push(outOfScheduleFlag);

                    // if outside of technician's schedule, mark as unavailable
                    if (availableTimeSlot) {
                        if (timeslots[j][i].outOfSchedule) {
                            availableTimeSlot = false;
                        }
                    }

                    // if the date/time is before the current time, mark it as disabled
                    if (new Date(timeslots[j][i].date + ' ' + timeslots[j][i].starttime) < new Date()) {
                        availableTimeSlot = false;
                    }

                    // check to see if the number of slots before and after the current appointment are available
                    for (let k = 1; k <= slotsBefore; k++) {
                        if (i - k >= 0) {
                            if (timeslots[j][i - k].occupied || timeslots[j][i - k].outOfSchedule) {
                                availableTimeSlot = false;
                                break;
                            }
                        }
                    }

                    for (let k = 1; k <= slotsAfter; k++) {
                        if (i + k < 96) {
                            if (timeslots[j][i + k].occupied || timeslots[j][i + k].outOfSchedule) {
                                availableTimeSlot = false;
                                break;
                            }
                        }
                    }

                    avail.push(availableTimeSlot);
                    selected.push(timeslots[j][i].selected);
                    if (j === 0) date1 = timeslots[j][i].date;
                    if (j === 1) date2 = timeslots[j][i].date;
                    if (j === 2) date3 = timeslots[j][i].date;
                    if (j === 3) date4 = timeslots[j][i].date;
                    if (j === 4) date5 = timeslots[j][i].date;
                    if (j === 5) date6 = timeslots[j][i].date;
                    if (j === 6) date7 = timeslots[j][i].date;
                }

                const slotkey = `${i}`;

                appointmentSlotHtml.push(
                    <AppointmentRow
                        key={i}
                        slotkey={slotkey}
                        appointmentTime={timeslots[0][i].starttime}
                        custstarttime={timeslots[0][i].custstarttime}
                        avail={avail}
                        outOfSchedule={outOfSchedule}
                        selected={selected}
                    />
                );
            }
            console.log('appointmentSlotHtml:', appointmentSlotHtml);
        }

        console.log('showAppointment:', showAppointment);
        console.log('weekStartDate:', weekStartDate);
        console.log('weekEndDate:', weekEndDate);

        if (showAppointment && weekStartDate && weekEndDate) {
            console.log('appointmentStartDate:', weekStartDate);
            console.log('appointmentEndDate:', weekEndDate);
            const today = new Date();
            console.log('today:', today);
            showLeftDateButton = today < new Date(weekStartDate);
            const oneYearFromToday = new Date();
            console.log('oneYearFromToday before setting year:', oneYearFromToday);
            oneYearFromToday.setFullYear(oneYearFromToday.getFullYear() + 1);
            showRightDateButton = today < oneYearFromToday;
            console.log('showLeftDateButton:', showLeftDateButton, 'showRightDateButton:', showRightDateButton);
        }


        return (
            <div className="divFull" align="center">
                <Header header2={this.props.pianoTechCustomer.title} />
                <Message message={this.props.pianoTechCustomer.message}
                    type={this.props.pianoTechCustomer.messageType} />
                <br />
                <table size="100%">
                    <tbody>
                        <tr><td width="40%" className="column1of2">
                            <table>
                                <tr>
                                    <td>
                                        <Button className="bluebutton2" description="Return to List" onClick={this.returnToList} />
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                                {this.props.pianoTechCustomer.maintenanceType !== 'add' &&
                                    <FormField row form={{ title: 'Customer Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                        name="customerId"
                                        value={pianoTechCustomer.customerId}
                                        onChange={this.onChange}
                                    />
                                }
                                {adminUser && !simulatingUser &&
                                    <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                                        name="companyId"
                                        value={pianoTechCustomer.companyId}
                                        onChange={this.onChange}
                                    />
                                }
                                <FormField row form={{ title: 'Customer Name', type: 'textinput', length: '80', maxLength: '80', disabled }}
                                    name="customerName"
                                    value={pianoTechCustomer.customerName}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'AddressLine1', type: 'textinput', length: '100', maxLength: '100', disabled }}
                                    name="addressLine1"
                                    value={pianoTechCustomer.addressLine1}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'AddressLine2', type: 'textinput', length: '100', maxLength: '100', disabled }}
                                    name="addressLine2"
                                    value={pianoTechCustomer.addressLine2}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'City', type: 'textinput', length: '100', maxLength: '100', disabled }}
                                    name="city"
                                    value={pianoTechCustomer.city}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'State', type: 'textinput', length: '20', maxLength: '20', disabled }}
                                    name="state"
                                    value={pianoTechCustomer.state}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Country', type: 'textinput', length: '50', maxLength: '50', disabled }}
                                    name="country"
                                    value={pianoTechCustomer.country}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Email', type: 'textinput', length: '100', maxLength: '100', disabled }}
                                    name="email"
                                    value={pianoTechCustomer.email}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Phone', type: 'textinput', length: '100', maxLength: '100', disabled }}
                                    name="encryptedPhone"
                                    value={pianoTechCustomer.encryptedPhone}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'TextOptOut', type: 'checkbox', disabled }}
                                    name="textOptOut"
                                    value={pianoTechCustomer.textOptOut}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'EmailOptOut', type: 'checkbox', disabled }}
                                    name="emailOptOut"
                                    value={pianoTechCustomer.emailOptOut}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Notes', type: 'textinput', length: '1000', maxLength: '1000', disabled }}
                                    name="notes"
                                    value={pianoTechCustomer.notes}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Time Zone', type: 'select', options: timeZones, optionTitle: 'description', optionValue: 'minutesFromUTC', disabled }}
                                    name="utcHoursAdjustment"
                                    value={pianoTechCustomer.utcHoursAdjustment}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Travel Time Before Appointment Minutes', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled: appointmentDisabled }}
                                    name="defaultBeforeAppointmentMinutes"
                                    value={pianoTechCustomer.defaultBeforeAppointmentMinutes}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Travel Time After Appointment Minutes', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled: appointmentDisabled }}
                                    name="defaultAfterAppointmentMinutes"
                                    value={pianoTechCustomer.defaultAfterAppointmentMinutes}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Created', type: 'textinput', length: '0', maxLength: '0', disabled }}
                                    name="created"
                                    value={pianoTechCustomer.created}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '0', maxLength: '0', disabled }}
                                    name="lastUpdated"
                                    value={pianoTechCustomer.lastUpdated}
                                    onChange={this.onChange}
                                />
                                <tr>
                                    <td>
                                        {showEdit &&
                                            <Button className="bluebutton" description="Edit" onClick={this.editPianoTechCustomer} />
                                        }
                                        {showDelete &&
                                            <Button className="bluebutton2" description={deleteText} onClick={this.onDelete} />
                                        }
                                        {showSave &&
                                            <div>
                                                <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                                <Button className="bluebutton2" description="Validate" onClick={this.validate} />
                                            </div>
                                        }
                                    </td>
                                    <td>
                                        <Button className="bluebutton2" description={cancelCloseText} onClick={this.onCancelClose} />
                                    </td>
                                </tr>
                            </table>
                            <table>
                                <td>
                                    <td width="75%" className="column2of2"></td>
                                </td>
                            </table>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td>
                                            <Button className="bluebutton" description="Add Piano" onClick={this.addPiano} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <DataTable
                                title="Customer's Piano List"
                                className='app-table'
                                columns={pianoColumns}
                                customStyles={customStyles}
                                striped
                                data={displayPianoTechList}
                                defaultSortField="nickname"
                                highlightOnHover
                                pagination
                                onRowClicked={
                                    (row) => { this.viewPianoTechPiano(row.pianoId) }
                                }
                            />
                            {viewingPiano &&
                                <React.Fragment>
                                    <Message message={this.props.pianoTechPiano.message}
                                        type={this.props.pianoTechPiano.messageType} />
                                    <br />
                                    <table className='tableMedium'>
                                        <tbody>
                                            {this.props.pianoTechPiano.maintenanceType !== 'add' &&
                                                <FormField row form={{ title: 'Piano Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                                    name="pianoId"
                                                    value={pianoTechPiano.pianoId}
                                                    onChange={this.onPianoChange}
                                                />
                                            }
                                            {adminUser && !simulatingUser &&
                                                <React.Fragment>
                                                    <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                                                        name="companyId"
                                                        value={pianoTechPiano.companyId}
                                                        onChange={this.onPianoChange}
                                                    />
                                                    <FormField row form={{ title: 'Customer Id', type: 'textinput', length: '10', maxLength: '10', disabled }}
                                                        name="customerId"
                                                        value={pianoTechPiano.customerId}
                                                        onChange={this.onPianoChange}
                                                    />
                                                </React.Fragment>
                                            }
                                            <FormField row form={{ title: 'Device Type', type: 'textinput', length: '50', maxLength: '50' }}
                                                name="deviceType"
                                                value={pianoTechPiano.deviceType}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Year', type: 'textinput', length: '20', maxLength: '20' }}
                                                name="year"
                                                value={pianoTechPiano.year}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Make', type: 'textinput', length: '100', maxLength: '100' }}
                                                name="make"
                                                value={pianoTechPiano.make}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Model', type: 'textinput', length: '100', maxLength: '100' }}
                                                name="model"
                                                value={pianoTechPiano.model}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'SerialNumber', type: 'textinput', length: '100', maxLength: '100' }}
                                                name="serialNumber"
                                                value={pianoTechPiano.serialNumber}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Nickname', type: 'textinput', length: '100', maxLength: '100' }}
                                                name="nickname"
                                                value={pianoTechPiano.nickname}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'DefaultMinutesPerAppointment', type: 'textinput', length: '10', maxLength: '10' }}
                                                name="defaultMinutesPerAppointment"
                                                value={pianoTechPiano.defaultMinutesPerAppointment}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Normal Months Between Tunings', type: 'textinput', length: '3', maxLength: '3' }}
                                                name="normalMonthsBetweenTunnings"
                                                value={pianoTechPiano.normalMonthsBetweenTunnings}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Notes', type: 'textinput', length: '5000', maxLength: '5000' }}
                                                name="notes"
                                                value={pianoTechPiano.notes}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Last Piano Tune', type: 'datetime-local', length: '19', maxLength: '19' }}
                                                name="lastPianoTune"
                                                value={pianoTechPiano.lastPianoTune}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Created', type: 'textinput', length: '19', maxLength: '19', disabled: true }}
                                                name="created"
                                                value={pianoTechPiano.created}
                                                onChange={this.onPianoChange}
                                            />
                                            <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '19', maxLength: '19', disabled: true }}
                                                name="lastUpdated"
                                                value={pianoTechPiano.lastUpdated}
                                                onChange={this.onPianoChange}
                                            />
                                            <tr>
                                                <td>
                                                    {!pianoMaintenanceComplete &&
                                                        <div>
                                                            <Button className="bluebutton" description="Save" disabled={disablePianoSave} onClick={this.onPianoSave} />
                                                            <Button className="bluebutton2" description="Validate" onClick={this.onPianoValidate} />
                                                            {this.props.pianoTechPiano.pianoId !== '0' &&
                                                                <Button className="bluebutton2" description={pianoDeleteText} onClick={this.onPianoDelete} />
                                                            }
                                                        </div>
                                                    }
                                                </td>
                                                <td>
                                                    <Button className="bluebutton2" description={pianoCancelCloseText} onClick={this.onPianoCancelClose} />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </React.Fragment>
                            }
                            {showAppointmentTable &&
                                <React.Fragment>
                                    <table width="100%">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Button className="bluebutton2-wide" description="Hide Appointments" onClick={this.hideAppointments} />
                                                    {!showAppointment &&
                                                        <Button className="bluebutton2-wide" description="Add Appointment" onClick={this.showAddAppointment} />
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <DataTable
                                        title={`Appointments for ${pianoName}`}
                                        className='app-table'
                                        columns={appointmentColumns}
                                        customStyles={customStyles}
                                        striped
                                        data={displayAppointments}
                                        defaultSortField="appointmentDate"
                                        highlightOnHover
                                        pagination
                                        onRowClicked={
                                            (row) => { this.viewAppointment(row.appointmentId) }
                                        }
                                    />

                                </React.Fragment>
                            }
                            {showAppointment && (
                                <React.Fragment>
                                    <Message message={this.props.pianoTechAppointment.message}
                                        type={this.props.pianoTechAppointment.messageType} />
                                    <br />
                                    <FormField row form={{ title: 'Tuning', type: 'checkbox', disabled: appointmentDisabled }}
                                        name="tuning"
                                        value={currentAppointment.tuning}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'ServiceReason', type: 'textinput', length: '100', maxLength: '100', disabled: appointmentDisabled }}
                                        name="serviceReason"
                                        value={currentAppointment.serviceReason}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Notes', type: 'textinput', length: '1000', maxLength: '1000', disabled: appointmentDisabled }}
                                        name="notes"
                                        value={currentAppointment.notes}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Travel Time Before Appointment Minutes', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled: appointmentDisabled }}
                                        name="minutesBefore"
                                        value={currentAppointment.minutesBefore}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Appointment Minutes', type: 'select', options: defaultAppointmentTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled: appointmentDisabled }}
                                        name="minutesRequired"
                                        value={currentAppointment.minutesRequired}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Travel Time After Appointment Minutes', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled: appointmentDisabled }}
                                        name="minutesAfter"
                                        value={currentAppointment.minutesAfter}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Block Start Time', type: 'textinput', length: '0', maxLength: '0', disabled: true }}
                                        name="blockStartTime"
                                        value={currentAppointment.displayBlockStartTime}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Appointment Start', type: 'textinput', length: '0', maxLength: '0', disabled: true }}
                                        name="appointmentTimeStart"
                                        value={currentAppointment.displayTimeStart}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Appointment End', type: 'textinput', length: '0', maxLength: '0', disabled: true }}
                                        name="appointmentTimeEnd"
                                        value={currentAppointment.displayTimeEnd}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Block End Time', type: 'textinput', length: '0', maxLength: '0', disabled: true }}
                                        name="blockEndTime"
                                        value={currentAppointment.displayBlockEndTime}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <FormField row form={{ title: 'Selected Technician', type: 'textinput', disabled: true }}
                                        name="technicianName"
                                        value={technicianName}
                                        onChange={this.onAppointmentChange}
                                    />
                                    <tr>
                                        <td>
                                            <div>
                                                {appointmentUpdateComplete && <div><b>Appointment update complete.</b></div>}
                                                {!appointmentUpdateComplete && (
                                                    <>
                                                        <Button className="bluebutton" description="Save" disabled={disableAppointmentSave} onClick={this.saveAppointment} />
                                                        <Button className="bluebutton2" description="Validate" onClick={this.onAppointmentValidate} />
                                                        {currentAppointment.appointmentId !== 0 &&
                                                            <Button className="bluebutton2" description={appointmentDeleteText} onClick={this.deleteAppointment} />
                                                        }
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            &nbsp;
                                        </td>
                                    </tr>
                                    {!appointmentUpdateComplete &&
                                        <React.Fragment>
                                            <tr>
                                                <td>
                                                    Scheduling for technician <b>{currentTechnicianName}</b>
                                                    <FormField row form={{ title: 'Select Technician to View Availability', type: 'select', options: pianoTechnicianList, optionTitle: 'technicianName', optionValue: 'techniciansId', noEmptyOption: true }}
                                                        name="selectedTechnicianId"
                                                        value={selectedTechnicianId}
                                                        onChange={this.onAppointmentChange}
                                                    />
                                                    <FormField row form={{ title: 'Hide Unavailable Slots', type: 'checkbox', disabled: appointmentDisabled }}
                                                        name="hideUnavailableSlots"
                                                        value={hideUnavailableSlots}
                                                        onChange={this.onHideUnavailableSlotsChange}
                                                    />

                                                </td>
                                            </tr>
                                            {showLeftDateButton &&
                                                <Button className="bluebutton2" description="Previous Week" onClick={this.onPreviousWeekClick} />
                                            }
                                            {showRightDateButton &&
                                                <Button className="bluebutton2" description="Next Week" onClick={this.onNextWeekClick} />
                                            }
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th width="12.5%">Tech Time(Cust Time)</th>
                                                        <th width="12.5%">Sun {date1}</th>
                                                        <th width="12.5%">Mon {date2}</th>
                                                        <th width="12.5%">Tue {date3}</th>
                                                        <th width="12.5%">Wed {date4}</th>
                                                        <th width="12.5%">Thu {date5}</th>
                                                        <th width="12.5%">Fri {date6}</th>
                                                        <th width="12.5%">Sat {date7}</th>
                                                    </tr>
                                                    {appointmentSlotHtml}
                                                </tbody>
                                            </table>
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            )}
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div >
        )
    }

}

export default connect(mapStateToProps)(PianoTechCustomer);
